import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { SkillService } from '../services/skill.service';
import { Location } from '@angular/common';
import { UserSkill, Expertise } from '../api-interfaces';
import 'rxjs/add/operator/takeUntil';
import { Subject, Observable } from 'rxjs';
import { FlashService } from '../../flash/flash.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-skill-update',
  templateUrl: './skill-update.component.html',
  styleUrls: ['./skill-update.component.css']
})
export class SkillUpdateComponent implements OnInit, OnDestroy {
  private destroy: Subject<void> = new Subject<void>();
  expertise: any = [];
  skillLists: UserSkill[] = [];
  skillUpdateForm: FormGroup;
  private newData = [];
  private oldData = [];
  private allData = [];
  private finalData;
  newSkills: any[] = [];
  arrLength;
  allSkills: any[] = [];
  currentUser = JSON.parse(localStorage.getItem("currentUser"));
  public document: Document;

  constructor(
    public skillService: SkillService,
    private location: Location,
    private formBuilder: FormBuilder,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    @Inject(DOCUMENT) document: any,
  ) {
    this.document = document;
    this.skillService.getExpertise().subscribe((res: any) => {
      this.expertise = res.sort(((a,b) => parseInt(a.expertise_weight) - parseInt(b.expertise_weight)));
    });

  }

  ngOnInit() {
    this.getSkillList();
  }
  ngOnDestroy() {
    this.destroy.next();
    this.destroy.unsubscribe();
  }

  formBuilding() {
    this.skillUpdateForm = new FormGroup({
      // newArray: this.typeArray(this.newData),
      allArray: this.typeArray(this.allData)
    })
  }


  typeArray(catList): FormArray {
    let controls = new FormArray([], [Validators.required]);
    catList.forEach(data => {
      data.category.forEach(dataCategory => {
        controls.push(this.formBuilder.group({
          category_id: dataCategory.category_id,
          category_name: dataCategory.category_name,
          skill: this.skillData(dataCategory)
        }));
      })
    });
    return controls;
  }

  skillData(dataCategory) {
    let arr = new FormArray([], [Validators.required])
    dataCategory.skill.forEach(y => {
      arr.push(this.formBuilder.group({
        skill_id: y.skill_id,
        skill_name: y.skill_name,
        expertise: y.expertise,
        expertise_id: y.expertise_id
      }))
    })
    this.arrLength = dataCategory.skill.length;
    return arr;
  }

  locationBack() {
    this.location.back();
  }

  getSkillList() {
    // this.spinnerService.show();
    this.skillService.getSkillList(this.currentUser.id).takeUntil(this.destroy).subscribe(
      data => {
        this.spinnerService.hide();
        this.skillLists = data;
        this.skillLists.filter(listdata => {
          if (listdata.type == 'new') {
            listdata.category = listdata.category.sort((a, b) => a.category_name.localeCompare(b.category_name));
            // this.newData = [listdata];
            this.newSkills = [listdata];
          }
          else {
            listdata.category = listdata.category.sort((a, b) => a.category_name.localeCompare(b.category_name));
            this.allData = [listdata];
            this.allSkills = this.allData;
          }
        })
        this.formBuilding();
      }, (error) => {
        this.flashService.show(error.error.message, 'alert-error');
      });
  }

  updateSkill(formdata) {
    this.spinnerService.show();
    this.finalData = [...formdata.value.newArray, ...formdata.value.oldArray];
    this.skillService.newSkillCreate(this.finalData, this.currentUser.id).takeUntil(this.destroy).subscribe(response => {
      this.spinnerService.hide();
      this.flashService.show('Skill name is updated successfully', 'alert-success');
    }, (error) => {
      this.spinnerService.hide();
      this.flashService.show('Skill updated failed', 'alert-error');
    });
  }

  updateSkillByExpertise(skillId, expertiseId) {
    if (+expertiseId == 0) return;
    this.spinnerService.show();
    this.skillService.newSkillCreateByExpertise(skillId, expertiseId, this.currentUser.id).takeUntil(this.destroy).subscribe(
      response => {
        this.spinnerService.hide();
        this.flashService.show('Skill name is updated successfully', 'alert-success');
        this.getSkillList();
      },
      error => {
        this.spinnerService.hide();
        this.flashService.show('Skill updated failed', 'alert-error');
      })
  }

  trackByFn(index) {
    return index;
  }

  /**
   * @param i index of skills category collapse span id.
   * @description Show the selected category span in viewpoint contain.
   */
  scrollTheViewPoint(i) {
    setTimeout(() => {
      const span = this.document.getElementById(`skillSpan${i}`);
      span.scrollIntoView({behavior: 'smooth'});
    }, 500)
  }

  /**
   * @param item New category name
   * @param olditem the oldskills array
   * @description The category index Append on new skill category button. for dynamic collaspe open.
   */
  collaspeIdAppend(item, olditem: any[]): number {
    return olditem.indexOf(olditem.filter(res => res.category_name === item)[0]);
  }

  /**
   * @param item
   * @param type
   * @description Show the count of Total, Updated, New skill status count.
   */
  skillsCountStatus(item, type, expertise) {
    switch(type) {
      case 'Total':
        return item.skill.length;
      case 'Updated':
        return item.skill.filter((res) => res.expertise_id !== expertise.filter(res => res.expertise_weight == 0)[0].expertise_id).length
      case 'New':
        return item.skill.filter((res) => res.expertise_id === expertise.filter(res => res.expertise_weight == 0)[0].expertise_id).length
    }
  }

  initLevel(expert_id, expertise) {
    if(expert_id && expertise) {
      return expert_id == expertise.filter(res => res.expertise_weight == 0)[0].expertise_id;
    }
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/skill-update/skill-update.component.ts